import { useDefaultTableStyling as sytlingOptions } from "./globalStyle"
import { Strings } from '../assets/res/en'
export default function groupDataColumn() {
    const columns = [
        { title: Strings.COLUMN_GROUP, field: 'description', validate: rowData => (rowData.description && rowData.description !== '') ? true : false },
        { title: Strings.COLUMN_SHORT_DESCRIPTION, field: 'shortDescription', validate: rowData => (rowData.shortDescription && rowData.shortDescription !== '') ? true : false },
        { title: Strings.COLUMN_STATUS, field: 'status', type: 'boolean', editable: 'never', hidden: true }
    ]
    return { columns, sytlingOptions }
}